import { SAVE_ITEM } from '../actionTypes';
import { companyUsersActions } from '../reducer';

import createUser from './createUser';
import updateUser from './updateUser';

export default (filterData, values) => (dispatch) => {
    const newValues = {
        confirm_password: values.confirm_password,
        email: values.email,
        first_name: values.first_name,
        is_enabled: values.is_enabled,
        last_name: values.last_name,
        password: values.password,
        phone: values.phone,
    };

    dispatch(companyUsersActions[SAVE_ITEM]());
    if (values.id) {
        dispatch(updateUser(filterData, values.id, newValues));
    } else {
        dispatch(createUser(filterData, newValues));
    }
};
